import Header from '../components/HeaderWide';
import Footer from '../components/Footer';

const LayoutWide = ({title, children }) => {
  return (
    <>
      <div className="min-h-screen flex flex-col dark:bg-gray-900">
        <Header title={title}/>
        <main className="flex-1">
          <div className="mx-auto max-w-7xl px-4 pb-12 sm:px-6 lg:px-8 min-h-[800px]">
              {children}
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}

export default LayoutWide;


